import { html, View } from 'rune-ts';

export type BonusBannerData = {
  active: boolean;
};

export class BonusBannerView extends View<BonusBannerData> {
  override template() {
    if (!this.data.active) {
      return html`<div class="bonus-banner hidden"></div>`;
    }
    return html`
      <div class="bonus-banner fixed left-1/2 -translate-x-1/2 z-40 px-3 py-1 rounded-full bg-gradient-to-r from-card-gold to-card-brass text-wood-ink text-sm font-bold shadow-lg animate-pulse" style="top: max(0.75rem, env(safe-area-inset-top));">
        보너스 — 한 번 더
      </div>
    `;
  }
}
